import { apiRequest } from "./api";

export async function submitFeedback(content, contact) {
  return apiRequest("/api/v1/me/feedback", {
    method: "POST",
    body: JSON.stringify({ content, contact }),
  });
}

export async function fetchMyFeedbackTickets(params = {}) {
  const search = new URLSearchParams();
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return apiRequest(`/api/v1/me/feedback${suffix}`);
}

export async function fetchMyFeedbackMessages(ticketId) {
  const payload = await apiRequest(`/api/v1/me/feedback/${ticketId}/messages`);
  return payload && Array.isArray(payload.messages) ? payload.messages : [];
}

export async function replyMyFeedback(ticketId, content) {
  return apiRequest(`/api/v1/me/feedback/${ticketId}/messages`, {
    method: "POST",
    body: JSON.stringify({ content }),
  });
}

export async function fetchMyFeedbackUnreadCount() {
  const payload = await apiRequest("/api/v1/me/feedback/unread-count");
  return payload && typeof payload.unread_count === "number" ? payload.unread_count : 0;
}

export async function fetchAdminFeedbackTickets(params = {}) {
  const search = new URLSearchParams();
  if (params.status) search.set("status", params.status);
  if (params.keyword) search.set("keyword", params.keyword);
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return apiRequest(`/api/v1/admin/feedback${suffix}`);
}

export async function fetchAdminFeedbackMessages(ticketId) {
  const payload = await apiRequest(`/api/v1/admin/feedback/${ticketId}/messages`);
  return payload && Array.isArray(payload.messages) ? payload.messages : [];
}

export async function replyAdminFeedback(ticketId, content) {
  return apiRequest(`/api/v1/admin/feedback/${ticketId}/messages`, {
    method: "POST",
    body: JSON.stringify({ content }),
  });
}

export async function updateAdminFeedbackStatus(ticketId, status) {
  return apiRequest(`/api/v1/admin/feedback/${ticketId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
}

export async function fetchAdminFeedbackUnreadCount() {
  const payload = await apiRequest("/api/v1/admin/feedback/unread-count");
  return payload && typeof payload.unread_count === "number" ? payload.unread_count : 0;
}
